export const subjectAreas = [
  {label: 'Agriculture', value: 'AGRICULTURE'},
  {label: 'Architecture', value: 'ARCHITECTURE'},
  {label: 'Arts and Media', value: 'ARTS_AND_MEDIA'},
  {label: 'Astrophysics and Astronomy', value: 'ASTROPHYSICS_AND_ASTRONOMY'},
  {label: 'Biochemistry', value: 'BIOCHEMISTRY'},
  {label: 'Biology', value: 'BIOLOGY'},
  {label: 'Behavioural Sciences', value: 'BEHAVIOURAL_SCIENCES'},
  {label: 'Chemistry', value: 'CHEMISTRY'},
  {label: 'Computer Science', value: 'COMPUTER_SCIENCE'},
  {label: 'Economics', value: 'ECONOMICS'},
  {label: 'Engineering', value: 'ENGINEERING'},
  {label: 'Environmental Science and Ecology', value: 'ENVIRONMENTAL_SCIENCE_AND_ECOLOGY'},
  {label: 'Ethnology', value: 'ETHNOLOGY'},
  {label: 'Geological Science', value: 'GEOLOGICAL_SCIENCE'},
  {label: 'Geography', value: 'GEOGRAPHY'},
  {label: 'History', value: 'HISTORY'},
  {label: 'Horticulture', value: 'HORTICULTURE'},
  {label: 'Information Technology', value: 'INFORMATION_TECHNOLOGY'},
  {label: 'Life Science', value: 'LIFE_SCIENCE'},
  {label: 'Linguistics', value: 'LINGUISTICS'},
  {label: 'Materials Science', value: 'MATERIALS_SCIENCE'},
  {label: 'Mathematics', value: 'MATHEMATICS'},
  {label: 'Medicine', value: 'MEDICINE'},
  {label: 'Philosophy', value: 'PHILOSOPHY'},
  {label: 'Physics', value: 'PHYSICS'},
  {label: 'Psychology', value: 'PSYCHOLOGY'},
  {label: 'Social Sciences', value: 'SOCIAL_SCIENCES'},
  {label: 'Software Technology', value: 'SOFTWARE_TECHNOLOGY'},
  {label: 'Sports', value: 'SPORTS'},
  {label: 'Theology', value: 'THEOLOGY'},
  {label: 'Veterinary Medicine', value: 'VETERINARY_MEDICINE'},
  {label: 'Other', value: 'OTHER'}
]
